// extracted by mini-css-extract-plugin
export default {"icon":"UnassignRoleplay_icon__qbXhW","unassign":"UnassignRoleplay_unassign__wo6SU"};